import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
const LatestFeedbackModel = types.model({
    accountId: types.maybeNull(types.integer),
    userId: types.maybeNull(types.integer),
    extensionVersion: types.maybeNull(types.string),
    browserType: types.maybeNull(types.string),
    starRating: types.maybeNull(types.integer),
    feedbackText: types.maybeNull(types.string),
    triggerAction: types.maybeNull(types.string),
    storeRedirected: types.maybeNull(types.boolean),
    dismissalType: types.maybeNull(types.string),
    feedbackId: types.maybeNull(types.string),
});
const ModelProps = {
    isLoaded: types.optional(types.boolean, false),
    isLoading: types.optional(types.boolean, false),
    isModalVisible: types.optional(types.boolean, false),
    firstOpenedAt: types.maybeNull(types.string),
    totalContactRevealsCount: types.maybeNull(types.number),
    lastOpenedAt: types.maybeNull(types.string),
    totalOpens: types.optional(types.integer, 0),
    showRatePopup: types.optional(types.boolean, false),
    latestFeedback: types.maybeNull(LatestFeedbackModel),
    currentTriggerAction: types.maybeNull(types.string),
    currentRate: types.maybeNull(types.integer),
};
const UserActivity = types.model(ModelProps).actions(Actions).views(Views);
export default UserActivity;
